import { render } from "./PatientTicketList.vue?vue&type=template&id=98be8b12"
import script from "./PatientTicketList.vue?vue&type=script&lang=js"
export * from "./PatientTicketList.vue?vue&type=script&lang=js"

import "./PatientTicketList.vue?vue&type=style&index=0&id=98be8b12&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__